"use client";

import { useCallback, useEffect, useState } from "react";

/** care_link_worker 向け。care_link_worker_mobile では使用しない */
/** iPhone 公開告知用（v1 で非表示済みのユーザーにも再度表示するためキーを更新） */
const STORAGE_KEY = "nativeAppReleaseModalHidden_v2";

export function useNativeAppReleaseModal() {
  const [shouldHide, setShouldHide] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      if (stored === "true") {
        setShouldHide(true);
      } else {
        setShouldHide(false);
      }
    } catch (error) {
      console.warn("Failed to read from localStorage:", error);
      setShouldHide(false);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  const setHideModal = useCallback((hide: boolean) => {
    try {
      if (hide) {
        localStorage.setItem(STORAGE_KEY, "true");
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
      setShouldHide(hide);
    } catch (error) {
      console.warn("Failed to write to localStorage:", error);
    }
  }, []);

  const shouldShowModal = useCallback(() => {
    if (!isLoaded) return false;
    if (shouldHide) return false;

    return true;
  }, [shouldHide, isLoaded]);

  return {
    shouldShowModal,
    setHideModal,
    isLoaded,
  };
}
